import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import ErrorBox from 'components/shared/ErrorBox';
import ThemeColor from 'components/shared/ThemeColor';

const ErrorPageOuterContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 20px;
`;

const ErrorPageInnerContainer = styled.div`
  width: 100%;

  @media only screen and (min-width: 768px) {
    width: 40%;
  }
`;

const ErrorPageLink = styled.div`
  a {
    font-family: 'CircularStd-Bold';
    font-size: 20px;
    color: #1d4ed8;
  }

  margin-top: 20px;
  border-bottom: 2px solid #1d4ed8;
`;

const ErrorPage: React.FC = () => {
  return (
    <ThemeColor color="gray">
      <ErrorPageOuterContainer>
        <ErrorPageInnerContainer>
          <ErrorBox errorMessage="Sorry, we can't find the page you're looking for">
            <ErrorPageLink>
              <Link to="/">Click here to go back home</Link>
            </ErrorPageLink>
          </ErrorBox>
        </ErrorPageInnerContainer>
      </ErrorPageOuterContainer>
    </ThemeColor>
  );
};

export default ErrorPage;
